import React from "react";


const StudentSessionDetails = () => {
  return (
    <>
     
    </>
  );
};

export default StudentSessionDetails;
